import {
    RuleConditionType,
    RuleSource,
    TransactionRule,
} from "../../types/transactionRule";
import { TransactionRuleActionDto } from "./transaction-rule-action.dto";
import { TransactionRuleConditionDto } from "./transaction-rule-condition.dto";

export class TransactionRuleDto {
    id: string;
    workspaceId: string;
    conditions: TransactionRuleConditionDto[];
    actions: TransactionRuleActionDto[];
    source: RuleSource | null;
    order: number;
    groupId: string;
    accountNumber?: string;
    isDisabled?: boolean | null;

    constructor(rule: TransactionRule) {
        this.id = rule.id;
        this.workspaceId = rule.workspaceId;
        this.conditions = rule.conditions
            .map((condition) => new TransactionRuleConditionDto(condition))
            .sort((a) =>
                a.conditionType === RuleConditionType.ENTITY ? -1 : 1,
            );
        this.actions = rule.actions;
        this.source = rule.source;
        this.order = rule.order;
        this.groupId = rule.groupId;
        this.isDisabled = rule.isDisabled;
    }

    static deserialize(dto: TransactionRuleDto): TransactionRule {
        return {
            ...dto,
            conditions: dto.conditions.map(
                TransactionRuleConditionDto.deserialize,
            ),
            actions: dto.actions.map(TransactionRuleActionDto.deserialize),
            // this is required, because of the numeric type passed as string
            order: Number(dto.order),
        };
    }
}
